export default "__VITE_ASSET___CpadT4H__"